import { PixelCrop, PercentCrop } from 'react-image-crop';
import { imageZone } from './ZonesList/ZonesList.types';

export const translatePercentCropToPixel = (width: number, height: number, percentCrop: PercentCrop): PixelCrop => {
  return {
    unit: 'px',
    x: Math.round((percentCrop.x * width) / 100),
    y: Math.round((percentCrop.y * height) / 100),
    width: Math.round((percentCrop.width * width) / 100),
    height: Math.round((percentCrop.height * height) / 100),
  };
};

export const translateZoneToPixel = (width: number, height: number, zone: imageZone): PixelCrop => {
  return translatePercentCropToPixel(width, height, {
    x: zone.percentX1,
    y: zone.percentY1,
    width: zone.percentX2 - zone.percentX1,
    height: zone.percentY2 - zone.percentY1,
    unit: '%',
  });
};
